// Third party JS from TW24061353. Kept as is for time concerns.
jQuery('.product-features-wrapper').eq(0).before(jQuery('.con-tainer'));
jQuery('.purchase-details').after(jQuery('.product-usp.has-padding-top.is-flex'));
jQuery('.con-tainer').before(jQuery('.product-form-container ').eq(0));
// jQuery('.purchase-details__buttons .button.button--add-to-cart').click(function () {
// 	var ccc = 0;
// 	var timerccc = setInterval(function () {
// 		if (jQuery('section.w-section.section_continue[aria-hidden="false"] a.w-button.btn.csapps-ignore').length) {
// 			window.location.href = '/cart';
// 			clearInterval(timerccc);
// 		}
// 	}, 50);

// 	var tc = 0;
// 	var timertc = setInterval(function () {
// 		if (jQuery('#theme-ajax-cart.is-drawer.is-visible').length) {
// 			window.location.href = '/cart';

// 			clearInterval(timertc);
// 		}
// 		tc++;
// 	}, 50);

// 	jQuery('body').addClass('conv-buy');
// });

Element.prototype.appendAfter = function (element) {
	element.parentNode.insertBefore(this, element.nextSibling);
};
var imgSrcs = [
	'https://cdn.shopify.com/s/files/1/0573/3207/2636/files/Click.png?v=1691724458',
	'https://cdn.shopify.com/s/files/1/0573/3207/2636/files/finance.png?v=1691724458',
	'https://cdn.shopify.com/s/files/1/0573/3207/2636/files/install.png?v=1691724458',
	'https://cdn.shopify.com/s/files/1/0573/3207/2636/files/guarantee.png?v=1691724459',
	'https://cdn.shopify.com/s/files/1/0573/3207/2636/files/delivery_58313b72-d86a-45f3-940a-987f94abe48c.png?v=1691724457',
	'https://cdn.shopify.com/s/files/1/0573/3207/2636/files/price.png?v=1691724459',
];

var lnks = [
	'https://www.did.ie/pages/try-our-free-click-collect-service',
	'https://www.did.ie/pages/humm-finance-options',
	'https://www.did.ie/pages/installation-services',
	'https://www.did.ie/pages/about-did',
	'https://www.did.ie/pages/delivery',
	'https://www.did.ie/pages/price-match-promise',
];
var badgeTexts = [
	'Same-Day Click & Collect',
	'Finance Available',
	'Installation & Recycling',
	'Guaranteed Irish',
	'Fast & Reliable Delivery',
	'Price Match Promise',
];
var container = document.createElement('div');
container.className = 'simple-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'simple-img-container';
var y = document.querySelectorAll('.purchase-details')[0];
if (document.getElementsByClassName('simple-img-container').length == 0) {
	container.appendAfter(y);
	container.appendChild(imgContainer);
}

for (var i = 0; i < imgSrcs.length; i++) {
	var img = document.createElement('div');
	img.innerHTML =
		'<a href="' +
		lnks[i] +
		'"><div class="simple-badge-container"><img src="' +
		imgSrcs[i] +
		'"><span class="badge' +
		i +
		'">' +
		badgeTexts[i] +
		'</span></div></a>';
	imgContainer.appendChild(img);
	img.className = 'simple-badges-container';
}

// Don't know what this does
var lbb = 0;
var timerlbb = setInterval(function () {
	if (jQuery('lb-upsell-product-page-addon.hydrated').length) {
		//jQuery('.product-usp').eq(0).before(jQuery('lb-upsell-product-page-addon.hydrated'));

		clearInterval(timerlbb);
	}
	if (lbb > 200) {
		clearInterval(timerlbb);
	}
	lbb++;
}, 50);
